import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=047b35b6&scoped=true&"
import script from "./sign.vue?vue&type=script&lang=js&"
export * from "./sign.vue?vue&type=script&lang=js&"
import style0 from "./sign.vue?vue&type=style&index=0&id=047b35b6&lang=scss&scoped=true&"
import style1 from "./sign.vue?vue&type=style&index=1&id=047b35b6&lang=scss&scoped=true&"
import style2 from "./sign.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b35b6",
  null
  
)

export default component.exports